

<div class="products">
	<app-product-tile *ngFor="let mfb of mostFrequentlyBought" [product]="mfb.product" [mode]="'row'"></app-product-tile>
</div>